import { IDataReducer } from '../../models/generals/iDataReducer';

import { UPDATE_AUTH_ENTITY, UPDATE_AUTH_ENTITY_LOGOUT } from '../../constants/ActionTypes';
import { getAuthEntity, RemoveCredentialsEntity, setAuthEntity } from '@helpers/utils';
import AuthEntityClass, { IAuthEntity } from '../../models/redux/iAuthEntity';

const INIT_STATE = new AuthEntityClass(getAuthEntity());

export default (state = INIT_STATE, action: IDataReducer): IAuthEntity => {
  switch (action.type) {
    case UPDATE_AUTH_ENTITY_LOGOUT: {
      RemoveCredentialsEntity();
      return new AuthEntityClass();
    }

    case UPDATE_AUTH_ENTITY: {
      setAuthEntity(action.entity);
      return {
        ...state,
        authEntity: action.entity ?? null,
      };
    }
    default:
      return state;
  }
};
